import React, { useState, useEffect, } from "react"
import { useDispatch, useSelector, } from 'react-redux'
import Loading from '../../layouts/Loading'
import { authorise } from "../../../redux/actions/authActions"
import { deleteAccountAction, } from "../../../redux/actions/deleteAccountActions"

import "./DeleteAccountModal.scss"
import ErrorComponent from "../../layouts/ErrorComponent"

function DeleteAccountModal() {
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  const deleteAccountState = useSelector(
    state => state.deleteAccount,
  )

  useEffect(() => {
    setLoading(false)
  }, [])

  useEffect(() => {
    if (false === deleteAccountState.loading) {
      setLoading(false)
    }
    if (deleteAccountState.error) {
      setError(deleteAccountState.error)
    }
    if (deleteAccountState.data) {
      localStorage.removeItem("user-token")
      dispatch(authorise())
      window.location = "/"
    }
  }, [deleteAccountState])

  const onSubmit = () => {
    setLoading(true)
    dispatch(deleteAccountAction())
  }

  if (loading) {
    return <div className="container settings-container text-center">
      <Loading />
    </div>
  }

  return (
    <>
      <button
        type="button"
        className="btn joystick-danger-btn"
        data-bs-toggle="modal"
        data-bs-target="#delete-account-modal"
      >
        Delete Account
      </button>
      <div
        className="modal fade delete-account-modal"
        id="delete-account-modal"
        tabIndex="-1"
        aria-labelledby="delete-account-label"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header ">
              <h3
                className="modal-title"
                id="delete-account-label"
              >
                Delete Account
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="d-flex justify-content-center">
                <ErrorComponent error={error} classes="delete-account-error" />
              </div>
              <div className="text-center">
                Are you sure you want to delete your account?
              </div>
              <div className="align-items-center justify-content-center delete-account-btn-container">
                <button
                  className="btn joystick-success"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  No
                </button>
                <div className="delete-account-space"></div>
                <button
                  className="btn joystick-btn"
                  onClick={onSubmit}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default DeleteAccountModal
